import React, { useState } from "react";
import { TouchableOpacity } from "react-native";
import VDBIcon from "@components/icons/VDBIcon";
import { CheckBox, Spacer, VDBText } from "@components/atoms";
import { IconsVariant } from "@components/icons/VDBIcon";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { ActiveListViewItemProps } from "@scenes/searchResults/types";
import { VDBIcons } from "@utils/VDBIcons";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { useTranslation } from "react-i18next";

const ActiveListViewItemComponent = ({
  item,
  isActive,
  hideColumnOptions,
  onDragStart,
  onDragEnd,
  activeData,
}: ActiveListViewItemProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const [checkboxKey, setCheckboxKey] = useState(Math.random());
  const [groupChecked, setIsGroupChecked] = useState(
    item?.is_visible === undefined ? true : item.is_visible
  );
  const countInvisibleItems = (data: any[]) => {
    return data.filter((mItem) => mItem.is_visible === false).length;
  };
  const showErrorToast =
    activeData.length - 1 === countInvisibleItems(activeData);

  const checkBoxEvent = (_item: boolean) => {
    if (!showErrorToast || _item) {
      const updatedItem = { ...item, is_visible: _item };
      setIsGroupChecked(_item);
      hideColumnOptions(updatedItem);
    } else {
      setCheckboxKey(Math.random());
      setIsGroupChecked(true);
      showToast(
        "",
        t("ListViewScreen.toast.text"),
        ToastTypes.ERROR,
        true,
        true
      );
    }
  };

  return (
    <SelectedOptionParentContainer
      theme={theme}
      isActive={isActive}
      mLastOption={activeData.indexOf(item) === activeData.length - 1}
      mFirstOption={activeData.indexOf(item) === 0}
    >
      <DragIconContainer
        theme={theme}
        isActive={isActive}
        onPressIn={onDragStart}
        onPressOut={onDragEnd}
        onMouseDown={onDragStart}
        onMouseUp={onDragEnd}
        onTouchStart={onDragStart}
        onTouchEnd={onDragEnd}
      >
        <VDBIcon
          name={VDBIcons.DRAG_ALT}
          size={24}
          variant={IconsVariant.VDBCustom}
          color={theme["core-05"]}
        />
      </DragIconContainer>

      <OptionInfoContainer>
        <IconTextContainer>
          <Spacer size={SpaceType.Double} />
          <CheckBox
            key={checkboxKey}
            fillColor={theme["knob-bor"]}
            checkBoxSize={16}
            isChecked={groupChecked}
            onPress={checkBoxEvent}
          />

          <Spacer size={SpaceType.Double} />
          <VDBText color={theme["core-05"]} type={typography["Body-M"]}>
            {item.label}
          </VDBText>
        </IconTextContainer>
      </OptionInfoContainer>
    </SelectedOptionParentContainer>
  );
};

const SelectedOptionParentContainer = styled.View<any>`
  height: 56px;
  flex-direction: row;
  border-width: ${({ isActive }) => (isActive ? 2 : 0)}px;
  border-bottom-width: ${({ mLastOption }) => (mLastOption ? 0 : 1)}px;
  border-color: ${({ theme }) => theme["core-03"]};
  border-top-left-radius: ${({ isActive, mFirstOption }) =>
    isActive || mFirstOption ? 8 : 0}px;
  border-top-right-radius: ${({ isActive, mFirstOption }) =>
    isActive || mFirstOption ? 8 : 0}px;
  border-bottom-left-radius: ${({ isActive, mLastOption }) =>
    isActive || mLastOption ? 8 : 0}px;
  border-bottom-right-radius: ${({ isActive, mLastOption }) =>
    isActive || mLastOption ? 8 : 0}px;
  background-color: ${({ theme }) => theme["core-01"]};
  margin-start: ${({ isActive }) => (isActive ? 5 : 0)}px;
`;

const DragIconContainer = styled(TouchableOpacity)<any>`
  height: ${({ isActive }) => (isActive ? 54 : 56)}px;
  margin-start: ${({ isActive }) => (isActive ? -2 : 0)}px;
  width: 40px;
  align-items: center;
  justify-content: center;
  border-right-width: 1px;
  border-color: ${({ theme }) => theme["core-03"]};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme["extra-04"] : "#00000000"};
  border-top-left-radius: ${({ isActive }) => (isActive ? 8 : 0)}px;
  border-bottom-left-radius: ${({ isActive }) => (isActive ? 8 : 0)}px;
`;

const OptionInfoContainer = styled.View`
  height: 56px;
  flex: 1;
  justify-content: space-between;
  flex-direction: row;
`;
const IconTextContainer = styled.View`
  height: 56px;
  flex-direction: row;
  align-items: center;
  flex: 0.7;
`;

export default ActiveListViewItemComponent;
